import React from 'react';
import css from './TextInCircle.module.scss';
import classNames from 'classnames';

interface IProps {
    text: string;
    theme: string;
}

const TextInCircle = (props: IProps) => {
    const textLength = props.text.length;
    const diameter = textLength + 3;

    const circleStyle = {
        width: `${diameter}rem`,
        height: `${diameter}rem`,
        lineHeight: `${diameter}rem`,
    };

    const styleClasses = classNames(
        css.OrLiteral,
        {
            [css.OrLiteralSPM]: props.theme === 'toyotaSPM',
            [css.OrLiteralLM]: props.theme === 'lexusMonogram',
            [css.OrLiteralCV]: props.theme === 'chevrolet',
            [css.fontWeightBaseText]: props.theme === 'bmw' || props.theme === 'ford' || props.theme === 'infiniti' ||
            props.theme === 'honda' || props.theme === 'buick' || props.theme === 'mercedesBenz' || props.theme === 'mazda' ||
            props.theme === 'acura' || props.theme === 'genesis' || props.theme === 'lexus',

        },
    );

    return (
        <div className={css.OrLiteralWrapper} >
            <div className={styleClasses} style={circleStyle}>
                {props.text}
            </div>
        </div>
    );
};

export default TextInCircle;
